<template>
    <v-tabs v-model="tab" show-arrows grow>
        <v-tab key="inState" v-if="null !== this.$store.getters.user.state">
            In State
        </v-tab>
        <v-tab v-for="result in orderedResults" :key="result.title">
            {{ result.school_type }}
        </v-tab>

        <v-tab-item
            v-if="null !== this.$store.getters.user.state"
            key="inState"
            :transition="false"
            :reverse-transition="false"
        >
            <InStateSchoolList></InStateSchoolList>
        </v-tab-item>
        <v-tab-item
            v-for="result in orderedResults"
            :key="result.percentage"
            :transition="false"
            :reverse-transition="false"
        >
            <school-list
                :school-list="getSchoolList(result.school_type)"
            ></school-list>
        </v-tab-item>
    </v-tabs>
</template>

<script>
import schoolService from '../services/SchoolService';
import SchoolList from './SchoolList';
import InStateSchoolList from './InStateSchoolList';
import _ from 'lodash';
export default {
    name: 'ResultTabs',
    props: ['results'],
    data: () => ({
        tab: 0,
    }),
    components: {
        SchoolList,
        InStateSchoolList,
    },
    methods: {
        getSchoolList(schoolType) {
            return schoolService.getSchoolsByLevel(
                schoolType,
                this.$store.getters.schools
            );
        },
    },
    computed: {
        orderedResults: function() {
            const order = [
                'Low/Mid Tier',
                'Mid Tier',
                'Mid/High Tier',
                'High Tier',
                'Top Tier',
                'Osteopathic',
                'International',
            ];
            const ordered = _.sortBy(this.results.results, result => {
                return order.indexOf(result.school_type);
            });
            return ordered;
        },
    },
};
</script>

<style scoped>
.result-list-item {
    margin-bottom: 20px;
}
</style>
